import z from "zod";
import type { FormInputSchemaParams } from "@/lib/types/form/form-field";
import { parseDateDmY } from "@/lib/utils/date-format";

export default function formDateZodSchema({ required }: FormInputSchemaParams) {
	return z.string().superRefine((raw, ctx) => {
		const trimmed = raw.trim();
		if (trimmed.length === 0) {
			if (required) {
				ctx.addIssue({ code: "custom", message: "invalidDate" });
			}
			return;
		}
		if (!parseDateDmY(trimmed)) {
			ctx.addIssue({ code: "custom", message: "invalidDate" });
		}
	});
}
